// extracted by mini-css-extract-plugin
export default {"credits_card":"CreditsCard_credits_card__Dr-KK","image":"CreditsCard_image__ZfB4F","info":"CreditsCard_info__vUBQ-"};